(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-app-hero"] && !Shopify.designMode) return;
  try {
    
  class OnceAppHero extends HTMLElement {
    // Apple's hero timeline: two seconds with an ease-in-out cubic curve.
    static DURATION = 2000;
    static EASING = 'cubic-bezier(0.65, 0, 0.35, 1)';

    connectedCallback() {
      this.icon = this.querySelector('[data-intro="icon"]');
      this.name = this.querySelector('[data-intro="name"]');
      this.copy = this.querySelector('[data-intro="copy"]');
      this.buttons = this.querySelector('[data-intro="buttons"]');
      this.phones = [...this.querySelectorAll('.once-app-hero__phone')];

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const top = this.getBoundingClientRect().top;

      // Skip the intro when motion is reduced, or when the page opened already
      // scrolled past the hero (e.g. after a reload halfway down).
      if (reduceMotion || top > window.innerHeight || top < -this.offsetHeight / 2) {
        this.finish();
        return;
      }

      // Keep everything hidden until the icon and the phone screens have
      // loaded, so the animation doesn't play over half-loaded images. Like
      // Apple, give up waiting after a moment and play anyway.
      this.classList.add('is-waiting');
      const images = [this.icon, ...this.querySelectorAll('.once-app-hero__screen img')].filter(Boolean);
      const loaded = images.map((image) =>
        image.complete
          ? Promise.resolve()
          : new Promise((resolve) => {
              image.addEventListener('load', resolve, { once: true });
              image.addEventListener('error', resolve, { once: true });
            })
      );
      const timeout = new Promise((resolve) => setTimeout(resolve, 1500));
      Promise.race([Promise.all(loaded), timeout]).then(() => requestAnimationFrame(() => this.play()));
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.requestParallax, { capture: true });
      window.removeEventListener('resize', this.measureParallax);
    }

    play() {
      const { DURATION: duration, EASING: easing } = OnceAppHero;
      const viewport = window.innerHeight;
      const options = { duration, easing, fill: 'both' };
      this.animations = [];
      const animate = (element, keyframes, timing = options) => {
        if (!element) return;
        this.animations.push(element.animate(keyframes, timing));
      };

      // Measure before anything moves. The icon is laid out at its large size
      // (see the CSS), so it's sharp while it's big and shrinks with a scale.
      const iconRect = this.icon.getBoundingClientRect();
      const copyTop = this.copy.getBoundingClientRect().top;
      const sectionTop = Math.max(this.getBoundingClientRect().top, 0);

      // The icon starts centred in the part of the screen below the section's
      // top edge, then rises to its place as it shrinks.
      const iconStartY = sectionTop + (viewport - sectionTop) / 2 - (iconRect.top + iconRect.height / 2);
      const iconEndScale = this.icon.offsetWidth ? this.targetIconSize() / this.icon.offsetWidth : 1;

      // Everything below the icon starts just under the bottom of the screen.
      const riseY = viewport - copyTop;

      this.classList.remove('is-waiting');

      animate(this.icon, [
        { transform: `translateY(${iconStartY}px) scale(1)` },
        { transform: `translateY(0) scale(${iconEndScale})` },
      ]);
      animate(this.icon, [{ opacity: 0 }, { opacity: 1 }], { duration: 500, easing: 'ease-out', fill: 'both' });

      animate(this.copy, [{ transform: `translateY(${riseY}px)` }, { transform: 'none' }]);

      // Apple's rules say not to animate the App Store badge, so the badges
      // only travel with the text, exactly as they would if the page scrolled.
      animate(this.buttons, [{ transform: `translateY(${riseY}px)` }, { transform: 'none' }]);

      // The phones fan in: the middle one rises straight up, the others start
      // 200px further out per step from the middle.
      const middle = Math.floor((this.phones.length - 1) / 2);
      this.phones.forEach((phone, index) => {
        animate(phone, [
          { transform: `translate(${200 * (index - middle)}px, ${riseY}px)`, opacity: 0 },
          { transform: 'none', opacity: 1 },
        ]);
      });

      animate(this.name, [{ opacity: 0 }, { opacity: 1 }], { duration: 500, delay: 1500, easing, fill: 'both' });

      Promise.all(this.animations.map((animation) => animation.finished))
        .then(() => this.finish())
        .catch(() => {});
    }

    // The icon's finished size is a CSS variable that changes with the screen
    // width, so read it from the page.
    targetIconSize() {
      return parseFloat(getComputedStyle(this.icon).getPropertyValue('--once-app-hero-icon-size')) || 84;
    }

    // Swap to the finished layout (the icon laid out at its small size) and
    // drop the animations, which now match it exactly.
    finish() {
      this.classList.remove('is-waiting');
      this.classList.add('is-finished');
      this.animations?.forEach((animation) => animation.cancel());
      this.animations = null;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      this.startParallax();
    }

    // Like Apple's, the lower phones slide up by their extra top margin between
    // the top of the page and the point where they reach the top of the screen.
    startParallax() {
      this.lowered = this.phones.filter((phone) => parseFloat(getComputedStyle(phone).marginTop) > 0);
      if (!this.lowered.length) return;

      // On desktop Horizon scrolls the page inside .page-wrapper rather than
      // the window. Scroll events don't bubble, so listen on the document
      // during the capture phase to hear both.
      document.addEventListener('scroll', this.requestParallax, { capture: true, passive: true });
      window.addEventListener('resize', this.measureParallax);
      this.measureParallax();
    }

    scrolled() {
      return Math.max(window.scrollY, document.querySelector('.page-wrapper')?.scrollTop || 0);
    }

    measureParallax = () => {
      const scrolled = this.scrolled();
      this.lowered.forEach((phone) => (phone.style.translate = ''));
      this.ranges = this.lowered.map((phone) => {
        const shift = parseFloat(getComputedStyle(phone).marginTop);
        const end = phone.getBoundingClientRect().top + scrolled - shift;
        return { phone, shift, end: Math.max(end, 1) };
      });
      this.updateParallax();
    };

    requestParallax = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.updateParallax();
      });
    };

    updateParallax() {
      const scrolled = this.scrolled();
      this.ranges?.forEach(({ phone, shift, end }) => {
        const progress = Math.min(Math.max(scrolled / end, 0), 1);
        phone.style.translate = `0 ${-shift * progress}px`;
      });
    }
  }

  if (!customElements.get('once-app-hero')) {
    customElements.define('once-app-hero', OnceAppHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-app-library"] && !Shopify.designMode) return;
  try {
    
  class OnceAppLibrary extends HTMLElement {
    connectedCallback() {
      this.tabs = [...this.querySelectorAll('[data-library-tab]')];
      this.panels = [...this.querySelectorAll('[data-library-panel]')];

      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
      });

      this.querySelectorAll('[data-library-track]').forEach((track) => this.loop(track));
      this.select(0);
      this.setAttribute('data-ready', '');

      // In the theme editor, show a tab when it (or one of its cards) is picked
      // in the sidebar.
      this.addEventListener('shopify:block:select', (event) => {
        const index = this.panels.findIndex((panel) => event.target.contains(panel) || panel.contains(event.target));
        if (index >= 0) this.select(index);
      });
    }

    // Show one tab's row and hide the others.
    select(index, focus = false) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', i === index);
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.panels.forEach((panel, i) => (panel.hidden = i !== index));
      if (focus) this.tabs[index].focus();
    }

    // Left and right arrows move between the tabs, as in any tab list.
    onKeydown(event, index) {
      const step = { ArrowRight: 1, ArrowLeft: -1 }[event.key];
      if (!step) return;
      event.preventDefault();
      this.select((index + step + this.tabs.length) % this.tabs.length, true);
    }

    // Copy the cards once, so sliding the row by half its width lands exactly
    // where it started. The copies are hidden from screen readers.
    loop(track) {
      const cards = [...track.children];
      if (!cards.length) return;
      cards.forEach((card) => {
        const copy = card.cloneNode(true);
        copy.removeAttribute('data-shopify-editor-block');
        copy.setAttribute('aria-hidden', 'true');
        track.append(copy);
      });
      track.style.setProperty('--once-app-library-count', cards.length);
    }
  }

  if (!customElements.get('once-app-library')) {
    customElements.define('once-app-library', OnceAppLibrary);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-app-showcase"] && !Shopify.designMode) return;
  try {
    
  class OnceAppShowcase extends HTMLElement {
    connectedCallback() {
      this.display = this.querySelector('[data-as-display]');
      this.tabs = [...this.querySelectorAll('[data-as-tab]')];
      this.screens = [...this.querySelectorAll('[data-as-screen]')];
      this.indicator = this.querySelector('.once-as__indicator');
      this.replayButton = this.querySelector('[data-as-replay]');
      const captions = this.querySelector('[data-as-captions]');

      // Each tab block renders its screen and caption next to its button; move
      // them into the phone and under the tabs.
      this.screens.forEach((screen) => {
        screen.hidden = false;
        this.display.append(screen);
      });
      this.querySelectorAll('.once-as__tabs [data-as-caption]').forEach((caption) => {
        caption.hidden = false;
        captions.append(caption);
      });

      this.tabs.forEach((tab, i) => tab.addEventListener('click', () => this.select(i)));
      this.querySelector('.once-as__tabs').addEventListener('keydown', this.handleKeydown);
      this.replayButton.addEventListener('click', this.replay);
      document.addEventListener('shopify:block:select', this.handleEditorSelect);

      this.resizeObserver = new ResizeObserver(() => {
        this.moveIndicator(false);
        this.balanceWords();
      });
      this.resizeObserver.observe(this.querySelector('.once-as__tabs'));
      this.words = [...this.querySelectorAll('.once-as__word > *')];
      this.words.forEach((word) => this.resizeObserver.observe(word));
      this.select(0, { animate: false });

      this.setupScroll();
    }

    disconnectedCallback() {
      document.removeEventListener('shopify:block:select', this.handleEditorSelect);
      document.removeEventListener('scroll', this.requestFrame, { capture: true });
      window.removeEventListener('resize', this.requestFrame);
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }

    // The wordmark and the word are rarely the same width. Size the word to
    // match the wordmark, so both tuck the same way behind the phone and the
    // phone sits centred between them. The word's width is divided by its
    // current scale to get its natural width, so re-running this (it runs
    // whenever either one resizes) settles instead of growing each time.
    balanceWords() {
      const [wordmark, word] = this.words;
      const current = parseFloat(this.style.getPropertyValue('--once-as-end-scale')) || 1;
      const natural = word.offsetWidth / current;
      if (!wordmark.offsetWidth || !natural) return;
      const scale = Math.min(2, Math.max(0.5, wordmark.offsetWidth / natural));
      if (Math.abs(scale - current) > 0.005) this.style.setProperty('--once-as-end-scale', scale.toFixed(3));
    }

    // ---- Tabs ---------------------------------------------------------------

    select(index, { animate = true, focus = false } = {}) {
      if (index < 0 || index >= this.tabs.length) return;
      this.index = index;

      this.tabs.forEach((tab, i) => {
        const selected = i === index;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        const caption = document.getElementById(tab.getAttribute('aria-controls').replace('Screen', 'Caption'));
        caption?.classList.toggle('is-active', selected);
      });
      if (focus) this.tabs[index].focus();

      this.screens.forEach((screen, i) => {
        const active = i === index;
        screen.classList.toggle('is-active', active);
        screen.inert = !active;
        const video = screen.querySelector('video');
        if (!video) return;
        if (active) {
          video.currentTime = 0;
          video.play().catch(() => {});
          video.onended = () => (this.replayButton.hidden = false);
        } else {
          video.pause();
          video.onended = null;
        }
      });
      this.replayButton.hidden = true;
      this.moveIndicator(animate);
    }

    // The dark pill behind the selected tab slides to it.
    moveIndicator(animate) {
      const tab = this.tabs[this.index];
      if (!tab) return;
      this.indicator.style.transition = animate ? '' : 'none';
      this.indicator.style.width = `${tab.offsetWidth}px`;
      this.indicator.style.height = `${tab.offsetHeight}px`;
      this.indicator.style.transform = `translate(${tab.offsetLeft}px, ${tab.offsetTop}px)`;
      // Keep the selected tab in view when the row scrolls on phones.
      const list = tab.closest('.once-as__tabs');
      if (list.scrollWidth > list.clientWidth) {
        list.scrollTo({ left: tab.offsetLeft - (list.clientWidth - tab.offsetWidth) / 2, behavior: animate ? 'smooth' : 'auto' });
      }
    }

    handleKeydown = (event) => {
      const keys = { ArrowRight: 1, ArrowLeft: -1, Home: -Infinity, End: Infinity };
      if (!(event.key in keys)) return;
      event.preventDefault();
      const step = keys[event.key];
      const next = Number.isFinite(step)
        ? (this.index + step + this.tabs.length) % this.tabs.length
        : step < 0 ? 0 : this.tabs.length - 1;
      this.select(next, { focus: true });
    };

    handleEditorSelect = (event) => {
      const tab = event.target.querySelector?.('[data-as-tab]');
      if (tab && this.contains(tab)) this.select(this.tabs.indexOf(tab));
    };

    replay = () => {
      const video = this.screens[this.index]?.querySelector('video');
      if (!video) return;
      this.replayButton.hidden = true;
      video.currentTime = 0;
      video.play().catch(() => {});
    };

    // ---- Scroll animation ---------------------------------------------------
    // Progress runs from 0, when the scene's top is a little way into the
    // bottom of the screen, to 1, when the scene is centred on it. The CSS reads
    // --once-as-q, which is 1 at the start and 0 when everything is in place
    // (also its value without this script, so nothing is ever left hidden).

    setupScroll() {
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.hasAttribute('data-animate') || reduceMotion) return;

      this.scene = this.querySelector('.once-as__scene');
      this.update();

      // Only follow the scroll while the section is near the screen. The page
      // scrolls inside Horizon's .page-wrapper on desktop, and scroll events
      // don't bubble, so listen on the document during the capture phase.
      this.visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          const method = entry.isIntersecting ? 'addEventListener' : 'removeEventListener';
          document[method]('scroll', this.requestFrame, { capture: true, passive: true });
          window[method]('resize', this.requestFrame);
          this.update();
        },
        { rootMargin: '25% 0px' }
      );
      this.visibilityObserver.observe(this);
    }

    requestFrame = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    };

    update() {
      const rect = this.scene.getBoundingClientRect();
      const viewport = window.innerHeight;
      const start = viewport * 0.9;
      const end = Math.min(start - 1, (viewport - rect.height) / 2);
      const progress = Math.min(1, Math.max(0, (start - rect.top) / (start - end)));
      const eased = 1 - Math.pow(1 - progress, 2);
      const q = 1 - eased;
      this.style.setProperty('--once-as-q', q.toFixed(4));
      this.style.setProperty('--once-as-q2', (q * q).toFixed(4));
    }
  }

  if (!customElements.get('once-app-showcase')) {
    customElements.define('once-app-showcase', OnceAppShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-carousel"] && !Shopify.designMode) return;
  try {
    
  class OnceCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.once-cr__track');
      this.cards = [...this.querySelectorAll('[data-cr-card]')];
      this.tabList = this.querySelector('.once-cr__tabs');
      this.indicator = this.querySelector('.once-cr__indicator');
      this.autoplayButton = this.querySelector('.once-cr__autoplay');
      this.ring = this.querySelector('.once-cr__ring-progress');
      if (!this.cards.length) return;

      // One tab per card, labelled from the card's "Tab label" setting.
      this.tabs = this.cards.map((card, i) => {
        const tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'once-cr__tab';
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', card.id);
        tab.textContent = card.dataset.label || `${i + 1}`;
        this.tabList.append(tab);
        return tab;
      });

      this.current = 0;
      this.userStopped = false;
      this.onScreen = false;
      this.autoplayAllowed =
        this.hasAttribute('data-autoplay') && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!this.hasAttribute('data-autoplay')) this.autoplayButton.hidden = true;

      this.addEventListener('click', this.handleClick);
      this.tabList.addEventListener('keydown', this.handleTabKeydown);
      this.track.addEventListener('scroll', this.handleScroll, { passive: true });
      this.track.addEventListener('scrollend', this.handleScrollEnd);
      // Swiping or scrolling the row by hand means the visitor has taken over.
      this.track.addEventListener('pointerdown', this.stopForGood, { passive: true });
      this.track.addEventListener('wheel', this.handleWheel, { passive: true });
      this.ring.addEventListener('animationend', this.handleTimerDone);
      document.addEventListener('shopify:block:select', this.handleEditorSelect);

      this.resizeObserver = new ResizeObserver(() => {
        this.placeIndicator();
        this.scrollToCard(this.current, false);
      });
      this.resizeObserver.observe(this.track);

      this.visibilityObserver = new IntersectionObserver(
        ([entry]) => {
          this.onScreen = entry.isIntersecting;
          this.syncAutoplay();
        },
        { threshold: 0.5 }
      );
      this.visibilityObserver.observe(this.track);

      this.setCurrent(0);
      this.classList.add('is-ready');
      this.syncAutoplay();
    }

    disconnectedCallback() {
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
      document.removeEventListener('shopify:block:select', this.handleEditorSelect);
    }

    handleClick = (event) => {
      const tab = event.target.closest('.once-cr__tab');
      if (tab) return this.goTo(this.tabs.indexOf(tab));

      if (event.target.closest('.once-cr__autoplay')) {
        this.userStopped = this.isPlaying();
        if (!this.userStopped) this.restartTimer();
        return this.syncAutoplay();
      }

      const card = event.target.closest('[data-cr-card]');
      if (!card) return;
      const index = this.cards.indexOf(card);

      // Clicking a dimmed card on either side brings it to the centre.
      if (index !== this.current) {
        event.preventDefault();
        return this.goTo(index);
      }

      if (event.target.closest('.once-cr__more')) this.togglePanel(card);
    };

    // Left and right arrows move between tabs, as a tab bar is expected to.
    handleTabKeydown = (event) => {
      const moves = { ArrowRight: 1, ArrowLeft: -1 };
      if (!(event.key in moves)) return;
      event.preventDefault();
      const next = (this.current + moves[event.key] + this.cards.length) % this.cards.length;
      this.goTo(next);
      this.tabs[next].focus();
    };

    handleWheel = (event) => {
      if (Math.abs(event.deltaX) > Math.abs(event.deltaY)) this.stopForGood();
    };

    stopForGood = () => {
      if (!this.userStopped) {
        this.userStopped = true;
        this.syncAutoplay();
      }
    };

    // While the visitor scrolls the row by hand, keep the tabs in step with
    // whichever card is nearest the middle.
    handleScroll = () => {
      if (this.scrollingTo !== undefined || this.scrollFrame) return;
      this.scrollFrame = requestAnimationFrame(() => {
        this.scrollFrame = null;
        const middle = this.track.scrollLeft + this.track.clientWidth / 2;
        let nearest = 0;
        this.cards.forEach((card, i) => {
          const distance = Math.abs(card.offsetLeft + card.offsetWidth / 2 - middle);
          const best = Math.abs(this.cards[nearest].offsetLeft + this.cards[nearest].offsetWidth / 2 - middle);
          if (distance < best) nearest = i;
        });
        if (nearest !== this.current) this.setCurrent(nearest);
      });
    };

    handleScrollEnd = () => {
      this.scrollingTo = undefined;
    };

    handleTimerDone = () => {
      this.goTo((this.current + 1) % this.cards.length);
    };

    handleEditorSelect = (event) => {
      const card = event.target.closest('[data-cr-card]');
      if (!card || !this.contains(card)) return;
      this.userStopped = true;
      this.goTo(this.cards.indexOf(card));
    };

    goTo(index) {
      if (index < 0 || index >= this.cards.length) return;
      this.setCurrent(index);
      this.scrollToCard(index, true);
      if (this.isPlaying()) this.restartTimer();
      // Moving on closes any open description, which may let autoplay resume.
      this.syncAutoplay();
    }

    scrollToCard(index, smooth) {
      const card = this.cards[index];
      const left = card.offsetLeft - (this.track.clientWidth - card.offsetWidth) / 2;
      if (smooth) {
        // Ignore the in-between cards the row passes on its way there.
        this.scrollingTo = index;
        clearTimeout(this.scrollFallback);
        this.scrollFallback = setTimeout(this.handleScrollEnd, 900);
      }
      this.track.scrollTo({ left, behavior: smooth ? 'smooth' : 'instant' });
    }

    setCurrent(index) {
      this.current = index;
      this.cards.forEach((card, i) => {
        const isCurrent = i === index;
        card.classList.toggle('is-current', isCurrent);
        card.setAttribute('aria-label', `${i + 1} of ${this.cards.length}`);
        if (!isCurrent) this.togglePanel(card, false);
      });
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
      });
      this.placeIndicator();
    }

    placeIndicator() {
      const tab = this.tabs?.[this.current];
      if (!tab) return;
      this.indicator.style.left = `${tab.offsetLeft}px`;
      this.indicator.style.width = `${tab.offsetWidth}px`;
    }

    togglePanel(card, force) {
      const open = force ?? !card.classList.contains('is-expanded');
      card.classList.toggle('is-expanded', open);
      const button = card.querySelector('.once-cr__more');
      button.setAttribute('aria-expanded', String(open));
      button.setAttribute('aria-label', open ? button.dataset.closeLabel : button.dataset.openLabel);
      card.querySelector('.once-cr__panel').inert = !open;
      if (force === undefined) this.syncAutoplay();
    }

    isPlaying() {
      return this.autoplayButton.dataset.state === 'playing';
    }

    // Autoplay runs only while it is allowed, on screen, not stopped by the
    // visitor, and no card's description is open.
    syncAutoplay() {
      if (!this.tabs) return;
      const panelOpen = this.cards.some((card) => card.classList.contains('is-expanded'));
      const wanted = this.autoplayAllowed && !this.userStopped;
      const running = wanted && this.onScreen && !panelOpen;

      this.autoplayButton.dataset.state = wanted ? 'playing' : 'paused';
      this.autoplayButton.setAttribute('aria-label', wanted ? 'Pause' : 'Play');
      if (running && !this.ring.classList.contains('is-timing')) this.restartTimer();
      this.ring.style.animationPlayState = running ? 'running' : 'paused';
    }

    restartTimer() {
      this.ring.classList.remove('is-timing');
      void this.ring.getBoundingClientRect();
      this.ring.classList.add('is-timing');
    }
  }

  if (!customElements.get('once-carousel')) {
    customElements.define('once-carousel', OnceCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-faq"] && !Shopify.designMode) return;
  try {
    
  class OnceFaq extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-faq-item]')];
      this.toggleAll = this.querySelector('[data-faq-toggle-all]');
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.items.forEach((item) => {
        item.querySelector('summary').addEventListener('click', (event) => {
          event.preventDefault();
          this.setOpen(item, !item.open);
          this.updateToggleAll();
        });
      });

      this.toggleAll?.addEventListener('click', () => {
        const open = !this.items.every((item) => item.open);
        this.items.forEach((item) => this.setOpen(item, open));
        this.updateToggleAll();
      });
    }

    // Open or close one question, gliding its answer to the new height. The
    // <details> stays open until the closing glide ends, so the answer is
    // visible while it shrinks.
    setOpen(item, open) {
      if (item.open === open && !item.dataset.closing) return;
      const answer = item.querySelector('[data-faq-answer]');
      item.animation?.cancel();

      if (open) {
        delete item.dataset.closing;
        item.open = true;
      } else {
        item.dataset.closing = '';
      }
      item.classList.toggle('is-open', open);

      if (this.reduceMotion) {
        if (!open) item.open = false;
        delete item.dataset.closing;
        return;
      }

      const height = answer.scrollHeight;
      item.animation = answer.animate(
        { height: open ? ['0px', `${height}px`] : [`${height}px`, '0px'], opacity: open ? [0, 1] : [1, 0] },
        { duration: 350, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );
      item.animation.onfinish = () => {
        if (!open) item.open = false;
        delete item.dataset.closing;
        item.animation = null;
      };
    }

    updateToggleAll() {
      if (!this.toggleAll) return;
      const allOpen = this.items.every((item) => item.classList.contains('is-open'));
      this.toggleAll.setAttribute('aria-expanded', String(allOpen));
      this.toggleAll.querySelector('[data-faq-toggle-label]').textContent = allOpen ? 'Collapse all' : 'Expand all';
    }
  }

  if (!customElements.get('once-faq')) {
    customElements.define('once-faq', OnceFaq);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-feature-explorer"] && !Shopify.designMode) return;
  try {
    
  class OnceFeatureExplorer extends HTMLElement {
    connectedCallback() {
      this.stage = this.querySelector('[data-fx-stage]');
      this.items = [...this.querySelectorAll('[data-fx-item]')];
      this.openIndex = -1;

      // Move each block's image out of the list and into the stage.
      this.querySelectorAll('.once-fx__list [data-fx-media]').forEach((media) => {
        media.classList.add('once-fx__media');
        this.stage.append(media);
      });

      // Start each Colours block on its first swatch.
      this.items.forEach((item) => {
        const swatch = item.querySelector('[data-fx-swatch]');
        if (swatch) this.selectSwatch(item, swatch);
      });

      this.addEventListener('click', this.handleClick);
      this.addEventListener('keydown', this.handleKeydown);
      document.addEventListener('shopify:block:select', this.handleEditorSelect);
      document.addEventListener('keydown', this.handleTabKey);
      document.addEventListener('pointerdown', this.handlePointer);
      this.list = this.querySelector('.once-fx__list');
      this.list.addEventListener('scroll', this.handleListScroll, { passive: true });
      this.update();
      this.setupModel();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.handleClick);
      this.removeEventListener('keydown', this.handleKeydown);
      document.removeEventListener('shopify:block:select', this.handleEditorSelect);
      document.removeEventListener('keydown', this.handleTabKey);
      document.removeEventListener('pointerdown', this.handlePointer);
      this.list.removeEventListener('scroll', this.handleListScroll);
      this.modelObserver?.disconnect();
      this.bleedObserver?.disconnect();
    }

    // Focus rings only show once the visitor is moving around with the Tab key.
    // Browsers also show them after Esc or a tap, when this section moves focus
    // back to a pill, which looks like a stray black border to everyone else.
    handleTabKey = (event) => {
      if (event.key === 'Tab') this.setAttribute('data-keyboard', '');
    };

    handlePointer = () => {
      this.removeAttribute('data-keyboard');
    };

    handleClick = (event) => {
      const pill = event.target.closest('.once-fx__pill');
      if (pill) return this.open(this.items.indexOf(pill.closest('[data-fx-item]')), true);

      const swatch = event.target.closest('[data-fx-swatch]');
      if (swatch) return this.selectSwatch(swatch.closest('[data-fx-item]'), swatch);

      if (event.target.closest('[data-fx-prev]')) return this.open(this.openIndex - 1, true);
      if (event.target.closest('[data-fx-next]')) return this.open(this.openIndex + 1, true);
      if (event.target.closest('[data-fx-close]')) return this.close();
    };

    // Phones: while a feature is open, every card sits open in one row that
    // scrolls sideways (the browser's own scrolling, so it's smooth) and snaps
    // to each card. Whichever card has settled at the start of the row is the
    // open feature, so the ring turns to it as the visitor swipes.
    isPhoneLayout() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    handleListScroll = () => {
      if (this.openIndex === -1 || !this.isPhoneLayout()) return;
      const start = this.list.getBoundingClientRect().left + parseFloat(getComputedStyle(this.list).scrollPaddingInlineStart || 0);
      let nearest = this.openIndex;
      let best = Infinity;
      this.items.forEach((item, i) => {
        const distance = Math.abs(item.getBoundingClientRect().left - start);
        if (distance < best) {
          best = distance;
          nearest = i;
        }
      });
      if (nearest === this.openIndex) return;
      this.openIndex = nearest;
      this.update();
    };

    // Brings the open card to the start of the row (phones only).
    scrollToOpen() {
      if (this.openIndex === -1 || !this.isPhoneLayout()) return;
      const item = this.items[this.openIndex];
      const padding = parseFloat(getComputedStyle(this.list).scrollPaddingInlineStart || 0);
      this.list.scrollTo({
        left: this.list.scrollLeft + item.getBoundingClientRect().left - this.list.getBoundingClientRect().left - padding,
        behavior: 'instant',
      });
    }

    handleKeydown = (event) => {
      if (event.key === 'Escape' && this.openIndex !== -1) {
        event.preventDefault();
        this.close();
      }
    };

    // Selecting a feature's block in the theme editor opens that feature.
    handleEditorSelect = (event) => {
      const item = event.target.closest('[data-fx-item]');
      if (item && this.contains(item)) this.open(this.items.indexOf(item), false);
    };

    open(index, moveFocus) {
      if (index < 0 || index >= this.items.length) return;
      this.openIndex = index;
      this.update();
      this.scrollToOpen();
      if (moveFocus) this.items[index].querySelector('.once-fx__card').focus({ preventScroll: true });
    }

    close() {
      const wasOpen = this.items[this.openIndex];
      const hadFocus = this.contains(document.activeElement);
      this.openIndex = -1;
      this.update();
      // Return focus to the pill that was open, so keyboard users are not lost.
      if (wasOpen && hadFocus) wasOpen.querySelector('.once-fx__pill').focus({ preventScroll: true });
    }

    selectSwatch(item, swatch) {
      item.querySelectorAll('[data-fx-swatch]').forEach((other) => {
        other.setAttribute('aria-checked', String(other === swatch));
      });
      const name = item.querySelector('[data-fx-color-name]');
      if (name) name.textContent = swatch.dataset.colorName;
      item.style.setProperty('--once-fx-dot', swatch.style.getPropertyValue('--once-fx-swatch'));
      item.dataset.mediaId = swatch.dataset.mediaId;
      item.dataset.variant = swatch.dataset.variant || '';

      // The finish label may already have moved into the model, so look it up
      // through the item's overlays as well as inside the item.
      const label = item.overlays?.find((overlay) => overlay.hasAttribute('data-fx-finish-label')) ||
        item.querySelector('[data-fx-finish-label]');
      if (label) {
        label.querySelector('[data-fx-finish-name]').textContent = swatch.dataset.colorName;
        label.style.setProperty('--once-fx-dot', swatch.style.getPropertyValue('--once-fx-swatch'));
        // Replay the fade so the new name eases in.
        label.classList.remove('is-changing');
        void label.offsetWidth;
        label.classList.add('is-changing');
      }
      this.update();
    }

    update() {
      const isOpen = this.openIndex !== -1;
      this.toggleAttribute('data-open', isOpen);

      // Measure the features about to open or close before anything changes, so
      // they can be animated from their old size to their new one.
      const changing = this.items.filter((item, i) => item.classList.contains('is-open') !== (i === this.openIndex));
      const before = new Map(changing.map((item) => [item, item.getBoundingClientRect()]));

      this.items.forEach((item, i) => {
        const selected = i === this.openIndex;
        item.classList.toggle('is-open', selected);
        item.querySelector('.once-fx__pill').setAttribute('aria-expanded', String(selected));
        // A closed card stays in the page (so it can fade), but out of reach of
        // the keyboard and screen readers.
        item.querySelector('.once-fx__card').inert = !selected;
      });

      if (this.canMorph()) changing.forEach((item) => this.morph(item, before.get(item)));

      this.querySelector('[data-fx-prev]').disabled = !isOpen || this.openIndex === 0;
      this.querySelector('[data-fx-next]').disabled = !isOpen || this.openIndex === this.items.length - 1;

      // Show the open feature's own image if it has one. Otherwise show the 3D
      // model, turned to that feature's camera angle, or the default image when
      // there is no model (or it has not loaded).
      const openItem = this.items[this.openIndex];
      const media = [...this.stage.querySelectorAll('[data-fx-media]')];
      const find = (id) => (id ? media.find((m) => m.dataset.fxMedia === id) : undefined);
      let target;
      if (this.modelReady) {
        // A swatch with a 3D variant uses the model even if it also has an image.
        const ownImage = openItem && !openItem.dataset.variant ? find(openItem.dataset.mediaId) : undefined;
        target = ownImage || this.modelMedia;
        if (target === this.modelMedia) this.aimModel(openItem);
        const showingModel = target === this.modelMedia;
        this.items.forEach((item) =>
          item.overlays?.forEach((overlay) => overlay.classList.toggle('is-visible', showingModel && item === openItem))
        );
      } else {
        target = (openItem && find(openItem.dataset.mediaId)) || find('default');
      }
      media.forEach((m) => m.classList.toggle('is-active', m === target));
    }
  }

  Object.assign(OnceFeatureExplorer.prototype, {
    // Loads the 3D viewer only when the section is about to scroll into view, and
    // only where the browser can draw 3D (WebGL). Until the model has loaded, the
    // default image stays, so a slow connection never shows an empty box.
    setupModel() {
      this.model = this.querySelector('model-viewer');
      if (!this.model) return;
      this.modelMedia = this.model.closest('[data-fx-media]');
      // Whether the theme editor allows dragging to rotate at all.
      this.canDrag = this.model.hasAttribute('camera-controls');
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.autoRotate = this.hasAttribute('data-auto-rotate') && !this.reducedMotion;

      const canvas = document.createElement('canvas');
      const canDraw3D = Boolean(canvas.getContext('webgl2') || canvas.getContext('webgl'));
      if (!canDraw3D || typeof window.Shopify?.loadFeatures !== 'function') return;

      this.model.addEventListener(
        'load',
        () => {
          this.modelReady = true;
          this.removeAttribute('data-model-loading');
          this.update();
        },
        { once: true }
      );
      this.showCamera = this.showCamera.bind(this);
      this.model.addEventListener('camera-change', this.showCamera);

      // Pin each feature's overlay into the model as a hotspot, so it stays on its
      // 3D point (e.g. the middle of the ring) wherever the camera goes.
      this.items.forEach((item, i) => {
        item.overlays = [...item.querySelectorAll('[data-fx-overlay]')];
        item.overlays.forEach((overlay, j) => {
          overlay.slot = `hotspot-once-fx-${i}-${j}`;
          this.model.append(overlay);
        });
      });

      // Fill the loading bar as the model downloads, and hide it once it is in.
      this.progressBar = this.querySelector('.once-fx__progress');
      this.model.addEventListener('progress', (event) => {
        const progress = event.detail.totalProgress;
        this.progressBar?.style.setProperty('--once-fx-progress', progress);
        this.toggleAttribute('data-model-loading', progress < 1);
      });
      this.model.addEventListener('error', () => this.removeAttribute('data-model-loading'));

      // On desktop the 3D canvas reaches all the way to the left edge of the screen
      // (and by the same amount past the right edge, where the section clips it),
      // so a close-up ring can sweep behind the pills and off the screen instead of
      // stopping at the edge of its box.
      this.bleedObserver = new ResizeObserver(() => this.updateBleed());
      this.bleedObserver.observe(this);
      this.updateBleed();

      this.modelObserver = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          this.modelObserver.disconnect();
          window.Shopify.loadFeatures([{ name: 'model-viewer', version: '1.12' }]);
        },
        { rootMargin: '100% 0px' }
      );
      this.modelObserver.observe(this);
    },

    // Turns the camera to a feature's angle (or the starting view when none is
    // open), and applies the selected colour's 3D material variant.
    aimModel(item) {
      const model = this.model;
      const colours = this.items.find((candidate) => candidate.dataset.variant);
      if (colours) model.variantName = colours.dataset.variant;
      const orbit = this.fitToScreen(item?.dataset.cameraOrbit || model.dataset.defaultOrbit);
      const target = item?.dataset.cameraTarget || model.dataset.defaultTarget;
      model.autoRotate = !item && this.autoRotate;
      // Dragging to rotate only works in the overview. Inside a feature the view
      // is fixed, so the chosen angle and its callouts stay lined up.
      model.cameraControls = !item && this.canDrag;

      // The slow spin turns the ring itself, not the camera, so a feature's camera
      // angle would land on whatever side the spin had reached. Undo the spin
      // first, moving the camera by the same amount so nothing visibly jumps, then
      // glide to the feature's view on the next frame. Every feature therefore
      // always ends up at exactly the same view.
      if (item && model.turntableRotation) {
        this.unspin(orbit);
        cancelAnimationFrame(this.aimFrame);
        this.aimFrame = requestAnimationFrame(() => this.setCamera(orbit, target));
        return;
      }
      this.setCamera(orbit, target);
    },

    updateBleed() {
      if (!window.matchMedia('(min-width: 750px)').matches) {
        this.style.removeProperty('--once-fx-bleed');
        return;
      }
      const toLeftEdge = this.stage.getBoundingClientRect().left - this.getBoundingClientRect().left;
      this.style.setProperty('--once-fx-bleed', `${Math.max(0, Math.round(toLeftEdge))}px`);
    },

    // Camera angles are chosen on desktop, where the 3D canvas is wide. A phone's
    // canvas is only as wide as the screen, so the same view would cut the ring
    // off at the sides; phones pull the camera back to keep it in frame. The
    // starting view is already wide, so it needs less pulling back than the
    // close-ups do.
    fitToScreen(orbit) {
      if (window.matchMedia('(min-width: 750px)').matches) return orbit;
      const parts = orbit.trim().split(/\s+/);
      const match = parts[2]?.match(/^([\d.]+)(m|%)$/);
      if (!match) return orbit;
      const scale = this.openIndex === -1 ? 1.55 : 2.35;
      parts[2] = `${parseFloat(match[1]) * scale}${match[2]}`;
      return parts.join(' ');
    },

    setCamera(orbit, target) {
      this.model.cameraOrbit = orbit;
      this.model.cameraTarget = target;
      if (this.reducedMotion) this.model.jumpCameraToGoal();
    },

    unspin(nextOrbit) {
      const model = this.model;
      const spin = model.turntableRotation;
      const current = model.getCameraOrbit();
      let theta = current.theta - spin;

      // Pick the equivalent angle closest to where the camera is heading, so it
      // takes the short way round rather than circling the ring.
      const [first] = nextOrbit.trim().split(/\s+/);
      const value = parseFloat(first);
      const next = first.endsWith('deg') ? (value * Math.PI) / 180 : first.endsWith('rad') ? value : null;
      if (next !== null && !Number.isNaN(next)) {
        theta = next + ((((theta - next) % (2 * Math.PI)) + 3 * Math.PI) % (2 * Math.PI)) - Math.PI;
      }

      model.resetTurntableRotation();
      model.cameraOrbit = `${theta}rad ${current.phi}rad ${current.radius}m`;
      model.jumpCameraToGoal();
    },

    // Theme editor only: shows the camera's current angle, in the same format the
    // "Camera angle" and "Focus point" settings take, so it can be copied across.
    // A callout whose label would run off the side of the screen (mostly on
    // phones) flips to the other side of its dot.
    keepCalloutsOnScreen() {
      const width = document.documentElement.clientWidth;
      this.querySelectorAll('.once-fx__callout.is-visible').forEach((callout) => {
        // Always start from the side chosen in the theme editor, so a flip made
        // while the camera was passing through never sticks.
        callout.dataset.side ??= callout.classList.contains('once-fx__callout--right') ? 'right' : callout.classList.contains('once-fx__callout--left') ? 'left' : '';
        const side = callout.dataset.side;
        if (!side) return;
        const other = side === 'left' ? 'right' : 'left';
        callout.classList.replace(`once-fx__callout--${other}`, `once-fx__callout--${side}`);
        const label = callout.querySelector('.once-fx__callout-label').getBoundingClientRect();
        const offScreen = side === 'left' ? label.left < 8 : label.right > width - 8;
        if (offScreen) callout.classList.replace(`once-fx__callout--${side}`, `once-fx__callout--${other}`);
      });
    },

    showCamera() {
      cancelAnimationFrame(this.calloutFrame);
      this.calloutFrame = requestAnimationFrame(() => this.keepCalloutsOnScreen());
      const helper = this.querySelector('[data-fx-camera-helper]');
      if (!helper || !this.model.getCameraOrbit) return;
      const orbit = this.model.getCameraOrbit();
      const target = this.model.getCameraTarget();
      const degrees = (radians) => `${Math.round((radians * 180) / Math.PI)}deg`;
      const metres = (value) => `${value.toFixed(3)}m`;
      helper.textContent =
        `Camera angle: ${degrees(orbit.theta)} ${degrees(orbit.phi)} ${metres(orbit.radius)}\n` +
        `Focus point: ${metres(target.x)} ${metres(target.y)} ${metres(target.z)}`;
    },

    // Only on desktop, where the pill and its card share a spot in the list. On
    // phones the card appears somewhere else (over the image), so it just fades.
    canMorph() {
      return (
        window.matchMedia('(min-width: 750px)').matches &&
        !window.matchMedia('(prefers-reduced-motion: reduce)').matches
      );
    },

    // Grows a pill into its card, or shrinks a card back into its pill, the way
    // Apple does: the grey shape itself changes size and the features below slide
    // along with it. CSS fades the label and the description in and out.
    morph(item, from) {
      const card = item.querySelector('.once-fx__card');
      item.getAnimations().forEach((animation) => animation.cancel());
      card.style.width = '';
      const to = item.getBoundingClientRect();
      if (Math.abs(from.width - to.width) < 1 && Math.abs(from.height - to.height) < 1) return;

      // Hold the card at its final width while the shape grows, so its text
      // does not re-wrap on every frame.
      if (item.classList.contains('is-open')) card.style.width = `${to.width}px`;

      const animation = item.animate(
        {
          width: [`${from.width}px`, `${to.width}px`],
          height: [`${from.height}px`, `${to.height}px`],
        },
        { duration: 500, easing: 'cubic-bezier(0.4, 0, 0.2, 1)' }
      );
      animation.onfinish = animation.oncancel = () => {
        card.style.width = '';
      };
    },
  });

  if (!customElements.get('once-feature-explorer')) {
    customElements.define('once-feature-explorer', OnceFeatureExplorer);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-gallery"] && !Shopify.designMode) return;
  try {
    
  class OnceGallery extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.once-gl__track');
      this.prev = this.querySelector('[data-gl-prev]');
      this.next = this.querySelector('[data-gl-next]');

      this.prev.addEventListener('click', () => this.page(-1));
      this.next.addEventListener('click', () => this.page(1));
      this.track.addEventListener('scroll', this.update, { passive: true });

      // The row's length changes with the screen width and as images load.
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.track);
      this.update();
    }

    disconnectedCallback() {
      this.track.removeEventListener('scroll', this.update);
      this.resizeObserver?.disconnect();
    }

    // Move one screenful. Cards snap to the start of the row, so the next card
    // that was cut off at the edge becomes the first one shown.
    page(direction) {
      const start = parseFloat(getComputedStyle(this.track).scrollPaddingInlineStart) || 0;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({
        left: direction * Math.max(1, this.track.clientWidth - start * 2),
        behavior: reduceMotion ? 'auto' : 'smooth',
      });
    }

    // Grey out an arrow when there's nothing more to show that way.
    update = () => {
      const { scrollLeft, scrollWidth, clientWidth } = this.track;
      const canScroll = scrollWidth > clientWidth + 1;
      this.toggleAttribute('data-static', !canScroll);
      this.prev.disabled = scrollLeft <= 1;
      this.next.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
    };
  }

  if (!customElements.get('once-gallery')) {
    customElements.define('once-gallery', OnceGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-intro"] && !Shopify.designMode) return;
  try {
    
  class OnceIntroText extends HTMLElement {
    connectedCallback() {
      const text = this.querySelector('.once-intro__text');
      if (!text || !this.hasAttribute('data-reveal')) return;
      if (!CSS.supports('animation-timeline', 'view()')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      // Wrap every word in a span, leaving the spaces between them (and any bold,
      // italic or links around them) exactly as they were.
      const walker = document.createTreeWalker(text, NodeFilter.SHOW_TEXT);
      const nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);

      const words = [];
      nodes.forEach((node) => {
        const fragment = document.createDocumentFragment();
        node.textContent.split(/(\s+)/).forEach((part) => {
          if (!part) return;
          if (/^\s+$/.test(part)) return fragment.append(part);
          const word = document.createElement('span');
          word.className = 'once-intro__word';
          word.textContent = part;
          words.push(word);
          fragment.append(word);
        });
        node.replaceWith(fragment);
      });

      // Each word gets its own slice of the scroll. They start filling in when the
      // paragraph comes up from the bottom of the screen, and the last word is done
      // by the time the paragraph reaches the middle.
      words.forEach((word, i) => {
        const start = 8 + (i / words.length) * 38;
        word.style.setProperty('--once-intro-start', `${start.toFixed(2)}%`);
        word.style.setProperty('--once-intro-end', `${(start + 6).toFixed(2)}%`);
      });

      this.classList.add('is-animated');
    }
  }

  if (!customElements.get('once-intro-text')) {
    customElements.define('once-intro-text', OnceIntroText);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-logo-marquee"] && !Shopify.designMode) return;
  try {
    
  class OnceLogoMarquee extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('.once-lg__viewport');
      this.group = this.querySelector('.once-lg__group');
      if (!this.group?.children.length) return;

      this.resizeObserver = new ResizeObserver(() => this.fill());
      this.resizeObserver.observe(this.viewport);
      this.resizeObserver.observe(this.group);

      // Only follow the logos along the curve while the row is on screen.
      this.visibilityObserver = new IntersectionObserver(([entry]) => {
        entry.isIntersecting ? this.startCurve() : this.stopCurve();
      });
      this.visibilityObserver.observe(this);
    }

    disconnectedCallback() {
      this.stopCurve();
      this.resizeObserver?.disconnect();
      this.visibilityObserver?.disconnect();
    }

    // The row glides left with a CSS animation; this lifts each logo onto a
    // gentle arch, like the logo row on pitch.com: highest in the middle of
    // the screen and dropping towards both edges. The arch is worked out from
    // where each logo is on screen right now, so it stays put while the logos
    // travel along it. Narrower screens get a shallower arch.
    startCurve() {
      if (this.curveFrame || !(parseFloat(this.dataset.curve) > 0)) return;
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const tick = () => {
        this.bendLogos();
        this.curveFrame = reduceMotion ? null : requestAnimationFrame(tick);
      };
      tick();
    }

    stopCurve() {
      cancelAnimationFrame(this.curveFrame);
      this.curveFrame = null;
    }

    bendLogos() {
      const box = this.viewport.getBoundingClientRect();
      if (!box.width) return;
      const half = box.width / 2;
      const middle = box.left + half;
      const height = parseFloat(this.dataset.curve) * Math.min(1, Math.max(0.5, box.width / 1440));
      this.querySelectorAll('.once-lg__logo').forEach((logo) => {
        const rect = logo.getBoundingClientRect();
        const along = (rect.left + rect.width / 2 - middle) / half;
        logo.style.transform = `translateY(${(height * along * along).toFixed(2)}px)`;
      });
    }

    // Repeat the set until the row is more than twice the screen width, and
    // time one full loop so the logos always move at the same speed.
    fill() {
      const width = this.group.offsetWidth;
      if (!width) return;
      const copies = Math.max(1, Math.ceil((this.viewport.clientWidth * 2) / width));
      const current = this.viewport.querySelectorAll('[data-lg-copy]');
      if (current.length !== copies) {
        current.forEach((copy) => copy.remove());
        for (let i = 0; i < copies; i++) {
          const copy = this.group.cloneNode(true);
          copy.setAttribute('data-lg-copy', '');
          copy.setAttribute('aria-hidden', 'true');
          copy.removeAttribute('aria-labelledby');
          copy.querySelectorAll('[data-shopify-editor-block]').forEach((el) => el.removeAttribute('data-shopify-editor-block'));
          this.viewport.append(copy);
        }
      }
      const speed = parseFloat(this.dataset.speed) || 36;
      this.style.setProperty('--once-lg-duration', `${(width / speed).toFixed(2)}s`);
      this.syncCopies();
    }

    // Each copy runs its own slide animation, and a copy added after the
    // first set has started would run behind it, opening a gap in the row
    // once a loop. Start every copy's animation at the same moment as the
    // first set's so they move as one strip.
    syncCopies() {
      const [lead] = this.group.getAnimations();
      if (!lead) return;
      lead.ready.then(() => {
        this.viewport.querySelectorAll('[data-lg-copy]').forEach((copy) => {
          copy.getAnimations().forEach((animation) => {
            animation.startTime = lead.startTime;
          });
        });
      });
    }
  }

  if (!customElements.get('once-logo-marquee')) {
    customElements.define('once-logo-marquee', OnceLogoMarquee);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["once-product-nav"] && !Shopify.designMode) return;
  try {
    
  class OnceProductNav extends HTMLElement {
    connectedCallback() {
      this.bar = this.querySelector('.once-pn__bar');
      this.offset = parseFloat(this.dataset.offset) || 0;

      // Pinned bars are placed by the page itself and never move.
      if (this.hasAttribute('data-pinned')) return;

      // In the theme editor, show the bar straight away so it can be edited.
      if (this.hasAttribute('data-design-mode')) return this.toggle(true);

      // On desktop Horizon scrolls the page inside .page-wrapper rather than
      // the window. Scroll events don't bubble, so listen on the document
      // during the capture phase to hear both.
      document.addEventListener('scroll', this.requestUpdate, { capture: true, passive: true });
      this.update();
    }

    disconnectedCallback() {
      document.removeEventListener('scroll', this.requestUpdate, { capture: true });
      this.toggle(false);
    }

    requestUpdate = () => {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    };

    // Normally the bar appears once the visitor has scrolled past the offset.
    // With "Always show" (as on Apple's spec pages) it's there from the start,
    // just under the site header, and moves up to the top of the screen once
    // they scroll past the offset.
    update() {
      const scroller = document.querySelector('.page-wrapper');
      const scrolled = Math.max(window.scrollY, scroller?.scrollTop || 0);
      const past = scrolled > this.offset;
      this.toggle(this.hasAttribute('data-always') || past, past);
    }

    toggle(show, past = show) {
      if (show !== this.shown) {
        this.shown = show;
        this.toggleAttribute('data-visible', show);
        // Hidden links can't be reached with the keyboard or read out.
        this.bar.inert = !show;
      }
      this.toggleAttribute('data-scrolled', past);
      if (this.hasAttribute('data-replace-header')) {
        document.documentElement.toggleAttribute('data-once-pn-visible', show && past);
      }
    }
  }

  if (!customElements.get('once-product-nav')) {
    customElements.define('once-product-nav', OnceProductNav);
  }

  } catch(e) { console.error(e); }
})();
})();
